export default __webpack_public_path__ + "images/a07ae87297535c15e63298af2510e192-arrowRight.svg";